module.exports = __webpack_public_path__ + "static/media/education.49cf4ee3.jpg";